import { useRegister } from "./RegisterContext";
import { useTranslation } from "react-i18next";



export default function StaffVerification() {
    const {
        details,
        verificationData,
        setVerificationData,
    } = useRegister();

    const { t } = useTranslation();

    const status = details.status || "";

    const needsLicence =
        status === "staffForm.coach" ||
        status === "staffForm.referee";

    const needsCertificate =
        [
            "staffForm.fitnessCoach",
            "staffForm.scout",
            "staffForm.videoAnalyst",
            "staffForm.physio",
            "staffForm.nutritionist",
            "staffForm.mentalCoach",
        ].includes(status);

    const handleFile = (e) => {
        const { name, files } = e.target;

        setVerificationData((prev) => ({
            ...prev,
            [name]: files[0],
        }));
    };

    const getMessage = () => {
        if (needsLicence) {
            return {
                title: t("staffVerification.requiredTitle"),
                text: t("staffVerification.licenceText"),
            };
        }

        return {
            title: t("staffVerification.requiredTitle"),
            text: t("staffVerification.certificateText"),
        };
    };

    const message = getMessage();

    return (
        <div className="verification-wrapper">

            <VerificationInfo
                title={message.title}
                text={message.text}
            />

            <div className="verification-content">

                <UploadBox
                    label={t("staffVerification.identity")}
                    name="own_id"
                    file={verificationData.own_id}
                    onChange={handleFile}
                />

                {needsLicence && (
                    <UploadBox
                        label={t("staffVerification.professionalLicense")}
                        name="staff_license"
                        file={verificationData.staff_license}
                        onChange={handleFile}
                    />
                )}

                {needsCertificate && (
                    <UploadBox
                        label={t("staffVerification.diploma")}
                        name="staff_certificate"
                        file={verificationData.staff_certificate}
                        onChange={handleFile}
                    />
                )}

            </div>

            <PrivacyNotice />

        </div>
    );
}

function VerificationInfo({ title, text }) {

    const { t } = useTranslation();

    return (
        <div className="verification-info-card">
            <div className="verification-badge">
                ✓ {t("staffVerification.carrerupVerification")}
            </div>

            <h3>{title}</h3>
            <p>{text}</p>
        </div>
    );
}

function PrivacyNotice() {

    const { t } = useTranslation();


    return (
        <div className="verification-privacy">
            🔒 {t("staffVerification.privacy")}
        </div>
    );
}

function UploadBox({ label, name, file, onChange }) {
    return (
        <div className="input-wrapper full-width">
            <label className="pdf-upload-label">
                {label}

                <input
                    required
                    type="file"
                    name={name}
                    accept=".pdf,image/*"
                    hidden
                    onChange={onChange}
                />
            </label>

            {file && (
                <div className="pdf-selected">
                    📄 {file.name}
                </div>
            )}
        </div>
    );
}